/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentGenerateSocialVersionMutationRequest, ContentGenerateSocialVersionMutationResponse, ContentGenerateSocialVersionPathParams } from "../models/ContentGenerateSocialVersion";

export function getContentGenerateSocialVersionUrl(id: ContentGenerateSocialVersionPathParams["id"], platform: ContentGenerateSocialVersionPathParams["platform"]) {
  const res = { method: 'PUT', url: `/contents/${id}/social-version/${platform}/generate` as const }  
  return res
}

/**
 * @summary Generate adapted version of the content for the target platform
 * {@link /contents/:id/social-version/:platform/generate}
 */
export async function contentGenerateSocialVersion(id: ContentGenerateSocialVersionPathParams["id"], platform: ContentGenerateSocialVersionPathParams["platform"], data?: ContentGenerateSocialVersionMutationRequest, config: Partial<RequestConfig<ContentGenerateSocialVersionMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentGenerateSocialVersionMutationResponse, ResponseErrorConfig<Error>, ContentGenerateSocialVersionMutationRequest>({ method : "PUT", url : getContentGenerateSocialVersionUrl(id, platform).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}